import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

import { isValidPhoneNumber as validatePhoneNumber } from 'libphonenumber-js';

const MAX_NUMBER_LENGTH = 16;
const PHONE_NUMBER_REGEXP = new RegExp('^\\+[1-9]\\d{1,14}$'); // E164 format

function checkPhoneNumberFn(control: AbstractControl): { invalidNumber: boolean } | null {
  if (control.value?.length > MAX_NUMBER_LENGTH) return null;

  return !control.value || isValidPhoneNumber(control.value) ? null : { invalidNumber: true };
}

export const isValidPhoneNumber = (number: string) =>
  validatePhoneNumber(number) && PHONE_NUMBER_REGEXP.test(number);

export const phoneNumberValidatorFn = <ValidatorFn>(
  Validators.compose([Validators.maxLength(MAX_NUMBER_LENGTH), checkPhoneNumberFn])
);
